import { styled as muiStyled } from '@mui/material';

import { Typography } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { LetterLabelProps } from './types';

export const LetterLabel = muiStyled(Typography)(
  ({ stayLetterFile }: LetterLabelProps) => ({
    display: 'flex',
    gap: '4px',
    color: NEW_COLORS.GRAYSCALE[700],
    ...(stayLetterFile && {
      color: NEW_COLORS.PRIMARY[500],
      textDecoration: 'underline',
      cursor: 'pointer',
    }),
  }),
);
